import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import RatingsOverview from './RatingsOverview';
import ReviewsList from './ReviewsList';
import Form from './Form';
import { SmallUppercase, Body } from 'scy/text';
import { SecondaryButton } from 'scy/buttons';
import { LightHR } from 'scy/HR';
import margin from 'scy/margin.mod.scss';
import styles from './Form.mod.scss';
import { track } from 'shared/models/analytic';

export default function RatingsAndReviews({ sku, ratings }) {
  if (!ratings) ratings = {};
  const stats = ratings.stats || {};
  const reviews = ratings.reviews ? ratings.reviews.data : [];
  const total = ratings.reviews ? ratings.reviews.total : 0;
  const per_page = ratings.reviews ? ratings.reviews.per_page : 0;
  const pageCount = Math.ceil(total / per_page);

  const [showForm, setShowForm] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const user = useSelector(state => state.login.user);
  const handleOnCancel = () => {
    setShowForm(false);
  };

  return (
    <>
      <SmallUppercase
        tag="h2"
        marginClass={`${margin.top_0} ${margin.bottom_sm}`}
      >
        Ratings & Reviews
      </SmallUppercase>

      {!user ? null : showForm ? (
        <Form
          user={user}
          sku={sku}
          onCancel={handleOnCancel}
          onSuccess={() => {
            setShowForm(false);
            setIsSuccess(true);
          }}
        />
      ) : isSuccess ? null : (
        <SecondaryButton
          onClick={() => {
            setShowForm(true);
            track('Product Review Clicked', {
              sku: sku
            });
          }}
          className={styles.button}
        >
          Write a Review
        </SecondaryButton>
      )}

      {!isSuccess && <RatingsOverview {...stats} />}

      {!!reviews.length && (
        <LightHR className={`${margin.top_md} ${margin.bottom_md}`} />
      )}

      {isSuccess && <Body>Thanks for submitting your review.</Body>}

      {!isSuccess && !showForm && !reviews.length && (
        <Body>Be the first to write a review.</Body>
      )}

      {!!reviews.length && !isSuccess && (
        <ReviewsList sku={sku} reviews={reviews} pageCount={pageCount} />
      )}
    </>
  );
}
